import coreStore from "./core-store";

const remoteResource = 'frontend/api/v1/dashboards';

export default coreStore.createCoreStore('dashboard', remoteResource);
